/*
 * Copyright (c) 2019. Sonrai Analytics Ltd.
 * Developed by Deva Sen. & Warren Dowey
 */

import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { environment } from '@env/environment';
import { AppLoaderComponent } from '@app/components/app-loader/app-loader.component';
import { extract } from '@app/services/i18n/i18n.service';

const routes: Routes = [
  {
    path: ':slug/:projectSlug',
    component: AppLoaderComponent,
    data: {
      title: `${environment.product_name} :: ${extract('App Name')}`,
      breadcrumb: [
        {
          label: 'Projects',
          url: '/projects',
        },
        {
          label: '{{projectSlug}}',
          url: '/project/:projectSlug',
        },
        {
          label: '{{slug}}',
          url: '',
        },
      ],
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [],
})
export class AppLoaderRoutingModule {}
